/**
 * TanStack Router Configuration
 * Main router instance with session-based navigation and state persistence
 */

import { Router } from '@tanstack/react-router';
import { routeTree } from './routeTree';
import { Loading } from '../components/common/Loading/Loading';
import { RouterError } from '../components/common/RouterError/RouterError';

// Create router instance with app-specific configuration
export const router = new Router({
  routeTree,

  // Default to preloading for better UX
  defaultPreload: 'intent',

  // Preload delay for hover interactions
  defaultPreloadDelay: 100,

  // Default Pending Component (Prevent Zombie State)
  defaultPendingComponent: Loading,

  // Default Error Component (Prevent Zombie State)
  defaultErrorComponent: ({ error }) => <RouterError error={error} />,
});

// Register router for TypeScript type inference
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
